import type { MetaFunction } from "react-router";
import Features from '@/pages/Features';

export const meta: MetaFunction = () => {
  return [
    { title: "An AI Assisted Copywriting Workflow for Real Humans | Arcitext" },
    {
      name: "description",
      content: "Lock in your writing style, get feedback on demand, and gain clarity before hitting publish. Arcitext helps you write like you, with confidence.",
    },
    {
      name: "keywords",
      content: "AI writing features, brand voice discovery, content analytics, writing assistant, brand consistency, AI copywriting, content quality tracking, voice analysis",
    },
    {
      tagName: "link",
      rel: "canonical",
      href: "https://www.arcitext.com/features",
    },
  ];
};

// This route uses static pre-rendering
export default function FeaturesRoute() {
  return <Features />;
}
